<template>
    <div v-if="errors" class="alert alert-danger" role="alert">
        <div v-for="(v, k) in errors" :key="k">
            <p v-for="error in v" :key="error">
                {{ $trans.get('__JSON__.' + error) }}
            </p>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-6">
            <div class="row">
                <div class="col-6 pe-0">
                    <div class="card shadow">
                        <div class="card-body">
                            <my-vacation-year :employee_id="employee_id" :year="(show_year - 1) + ''" />
                        </div>
                    </div>
                </div>
                <div class="col-6 pe-0">
                    <div class="card shadow">
                        <div class="card-body">
                            <my-vacation-year :employee_id="employee_id" :year="show_year + ''" />
                        </div>
                    </div>
                </div>
                <div class="col-12 pe-0 pt-2" v-if="vacationdata && vacationdata.afterContractDays > 0">
                    <div class="card shadow">
                        <div class="card-body">
                            <my-vacation-year-additional-infos :vacationdata="vacationdata" :employee="employee" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 ">
            <div class="row h-100">
                <div class="col-12">
                    <div class="card h-100 demo-wrap shadow">
                        <div class="card-body">
                            <div class="row h-100">
                                <div class="col text-center align-self-center">
                                    <a href="/my/vacationrequest" class="btn btn-xl btn-primary" id="vacationrequestlink">{{
                                        $trans.get('__JSON__.Request vacation')
                                    }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col">
            <div class="card shadow">
                <div class="card-body">
                    <employee-calendar :employee_id="employee_id" :start_year="show_year" start_month="1"
                        paging="off" :switch_years="switch_years" journallink="off" :key=reloadVersion :user=user />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getTransitionRawChildren, ref, watch } from "vue";

export default {
    name: "MyVacation",
    props: {
        employee_id: String,
        show_year: String,
        switch_years: String,
        user: Object
    },
    data() {
        return {
            employee: null,
            errors: null,
            vacationdata: null,
            reloadVersion: 0,
            yearSelected: null
        }
    },
    created() {
        this.getEmployee();
        this.getVacationData();
        this.yearSelected = window.location.search.substring(1).split('?')[0].split('=')[1];
    },
    methods: {
        getEmployee() {
            axios
                .get("/api/employees/" + this.employee_id)
                .then((resp) => {
                    this.employee = resp.data;
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });
        },
        getVacationData() {
            axios
                .get("/api/employees/" + this.employee_id + '/vacationdata')
                .then((resp) => {
                    this.vacationdata = resp.data;
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });

        },
    }
}
</script>
